module.exports = __webpack_public_path__ + "static/media/AggregateBoard.d91f7587.png";